import axios from "./axios"; // Import the centralized Axios instance

const state = {
  sales_order_menus: [],
};

const getters = {
  allSalesOrderMenus: (state) => state.sales_order_menus,
};

const actions = {
  async fetchSalesOrderMenus({ commit }) {
    try {
      commit("resetSalesOrderMenus");
      const response = await axios.get("/sales-order-menu", { params: { page: 1, limit: 25 } });
      commit("setSalesOrderMenus", response.data);
    } catch (error) {
      console.error("Failed to fetch sales_order_menus:", error);
    }
  },
  async createSalesOrderMenu({ commit }, sales_order_menu) {
    try {
      const response = await axios.post("/sales-order-menu", sales_order_menu);
      commit("addSalesOrderMenu", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create sales_order_menu:", error);
      throw error;
    }
  },
  async fetchSalesOrderMenuById(_, id) {
    try {
      const response = await axios.get(`/sales-order-menu/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_order_menu:", error);
      throw error;
    }
  },
  async updateSalesOrderMenu({ commit }, sales_order_menu) {
    try {
      const response = await axios.put(`/sales-order-menu/${sales_order_menu.id}`, sales_order_menu);
      commit("updateSalesOrderMenu", response.data);
    } catch (error) {
      console.error("Failed to update sales_order_menu:", error);
      throw error;
    }
  },
  async deleteSalesOrderMenuById({ commit }, id) {
    try {
      const response = await axios.delete(`/sales-order-menu/${id}`);
      commit("removeSalesOrderMenu", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete sales_order_menu:", error);
      throw error;
    }
  },
};

const mutations = {
  setSalesOrderMenus(state, sales_order_menus) {
    state.sales_order_menus = sales_order_menus.data; // Ensure this matches your API's response structure
  },
  addSalesOrderMenu(state, sales_order_menu) {
    state.sales_order_menus.push(sales_order_menu);
  },
  updateSalesOrderMenu(state, updatedSalesOrderMenu) {
    const index = state.sales_order_menus.findIndex(
      (sales_order_menu) => sales_order_menu.id === updatedSalesOrderMenu.id
    );
    if (index !== -1) {
      state.sales_order_menus.splice(index, 1, updatedSalesOrderMenu);
    }
  },
  removeSalesOrderMenu(state, id) {
    state.sales_order_menus = state.sales_order_menus.filter(
      (sales_order_menu) => sales_order_menu.id !== id
    );
  },
  resetSalesOrderMenus(state) {
    state.sales_order_menus = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
